import React from "react";
import {
  useAuth,
  useDispatch,
  useActions,
} from "../../context/security/AuthProvider";
import "./login.css";
import { faEye, faEyeSlash, faMessage, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { types } from "../../reducers/security/authReducer";
import { Link } from "react-router-dom";

const Login = () => {
  let stateAuth = useAuth();
  let dispatch = useDispatch();
  let actions = useActions();

  const { email, password } = stateAuth.loginForm;
  const { showPassword } = stateAuth;

  const handleChange = (e) => {
    dispatch({
      type: types.CHANGE_INPUT_LOGIN_FORM,
      payload: { name: e.target.name, value: e.target.value },
    });
  };

  return (
    <div className="flex login-general-container">
      <section className="flex vh100 flex1 login-left-section justify-right">
        <div className="flex flex-column margin-auto">
          <div className=" logo-login">
            <h1 className="txt-center font1">Accede a</h1>
            <div className="flex">
              <img
                className="margin-auto"
                src="/images/login/logoLogin.png"
                alt="image"
              />
            </div>
          </div>
          <div className="bubble-login">
            <form
              className="flex flex-column form-login"
              onSubmit={actions.fetchLogin}
            >
              <input
                onChange={handleChange}
                value={email}
                type="email"
                name="email"
                className="font3"
              />
              <div className="container-password-login">
                <input
                  onChange={handleChange}
                  value={password}
                  type={showPassword?"text":"password"}
                  name="password"
                  className="font3"
                />
                <FontAwesomeIcon
                  onClick={() =>
                    dispatch({
                      type: types.TOGGLE_PASSWORD
                    })
                  }
                  className="cursor-pointer"
                  icon={showPassword?faEyeSlash:faEye}
                />
              </div>

              <div className="group-button-login flex justify-betwen">

              <Link
               style={{ fontSize: "13px" }}
                  className="font2"
                  to={`/mailResetPassword`}
                >
                  Recuperar contraseña
                </Link>

                <button>Ingresar</button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <section className="login-rigth-section ">
        <div className="flex vh100 ">
          <div className="margin-auto container-contact-us">
            <h1 className="white">¿Aún no cuentas con LabStock?</h1>
            <div className="btn-contact-login cursor-pointer ">
              <a href="https://wa.me/+573202421487?text=Hola *Crhonos ISO Consultores*. Me gustaría conocer más sobre los servicios que ofrecen en LabStock">
                <FontAwesomeIcon icon={faPhone} />
                &nbsp;
                <label className="cursor-pointer">¡Contáctanos!</label>
              </a>
            </div>
            <img
              className="margin-auto"
              src="/images/crhonosWhite.png"
              alt="image"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
